// src/operator/console/super-admin-shell.tsx
//
// Shell de navigation pour l'espace super-admin.
// Sidebar verticale avec les liens vers chaque page.

import { createSignal, For, Show, type JSX } from "solid-js";
import { useNavigate, useLocation } from "@solidjs/router";
import "./super-admin-shell.css";

interface NavItem {
  id: string;
  label: string;
  path: string;
  icon: string;
}

const NAV_ITEMS: NavItem[] = [
  { id: "dashboard", label: "Dashboard", path: "/console/super-admin", icon: "◈" },
  { id: "tenants", label: "Tenants", path: "/console/super-admin/tenants", icon: "⌂" },
  { id: "users", label: "Utilisateurs", path: "/console/super-admin/users", icon: "◎" },
  { id: "plugins", label: "Plugins", path: "/console/super-admin/plugins", icon: "◫" },
  { id: "signalements", label: "Signalements", path: "/console/super-admin/signalements", icon: "⚑" },
  { id: "db-metrics", label: "DB Metrics", path: "/console/super-admin/db-metrics", icon: "◉" },
  { id: "clients-sessions", label: "Clients Sessions", path: "/console/super-admin/clients-sessions", icon: "◐" },
  { id: "cli-clients", label: "CLI Clients", path: "/console/super-admin/cli-clients", icon: "⌘" },
  { id: "relays", label: "Relays", path: "/console/super-admin/relays", icon: "⇄" },
  { id: "trace", label: "Trace Debug", path: "/console/super-admin/trace", icon: "✦" },
];

export function SuperAdminShell(props: { children?: JSX.Element; userEmail?: string }) {
  const navigate = useNavigate();
  const location = useLocation();
  const [collapsed, setCollapsed] = createSignal(false);

  function isActive(path: string) {
    const p = location.pathname;
    if (path === "/console/super-admin") return p === path;
    return p.startsWith(path);
  }

  return (
    <div class="super-admin-app">
      {/* ── Sidebar ── */}
      <aside class="super-admin-sidebar" data-collapsed={collapsed() ? "true" : "false"}>
        <div class="super-admin-sidebar-header">
          <span class="super-admin-sidebar-brand">S</span>
          <Show when={!collapsed()}>
            <span class="super-admin-sidebar-title">Super Admin</span>
          </Show>
        </div>

        <nav class="super-admin-sidebar-nav">
          <For each={NAV_ITEMS}>
            {(item) => (
              <button
                type="button"
                class="super-admin-sidebar-link"
                data-active={isActive(item.path) ? "true" : "false"}
                onClick={() => navigate(item.path)}
                title={item.label}
              >
                <span class="super-admin-sidebar-icon">{item.icon}</span>
                <Show when={!collapsed()}>
                  <span class="super-admin-sidebar-label">{item.label}</span>
                </Show>
              </button>
            )}
          </For>
        </nav>

        <div class="super-admin-sidebar-footer">
          <button
            type="button"
            class="super-admin-sidebar-toggle"
            onClick={() => setCollapsed((v) => !v)}
            title={collapsed() ? "Étendre" : "Réduire"}
          >
            {collapsed() ? "→" : "←"}
          </button>
          <Show when={!collapsed()}>
            <span class="super-admin-sidebar-user">{props.userEmail ?? "admin"}</span>
          </Show>
        </div>
      </aside>

      {/* ── Contenu ── */}
      <main class="super-admin-main">{props.children}</main>
    </div>
  );
}
